var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.2002 6.99961C4.2002 6.62831 4.34769 6.27221 4.61025 6.00966C4.8728 5.74711 5.22889 5.59961 5.6002 5.59961H22.4002C22.7715 5.59961 23.1276 5.74711 23.3901 6.00966C23.6527 6.27221 23.8002 6.62831 23.8002 6.99961C23.8002 7.37091 23.6527 7.72701 23.3901 7.98956C23.1276 8.25211 22.7715 8.39961 22.4002 8.39961H5.6002C5.22889 8.39961 4.8728 8.25211 4.61025 7.98956C4.34769 7.72701 4.2002 7.37091 4.2002 6.99961Z",
    fill: "#2D3134"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.2002 13.9996C4.2002 13.6283 4.34769 13.2722 4.61025 13.0097C4.8728 12.7471 5.22889 12.5996 5.6002 12.5996H22.4002C22.7715 12.5996 23.1276 12.7471 23.3901 13.0097C23.6527 13.2722 23.8002 13.6283 23.8002 13.9996C23.8002 14.3709 23.6527 14.727 23.3901 14.9896C23.1276 15.2521 22.7715 15.3996 22.4002 15.3996H5.6002C5.22889 15.3996 4.8728 15.2521 4.61025 14.9896C4.34769 14.727 4.2002 14.3709 4.2002 13.9996Z",
    fill: "#2D3134"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.2002 20.9996C4.2002 20.6283 4.34769 20.2722 4.61025 20.0097C4.8728 19.7471 5.22889 19.5996 5.6002 19.5996H22.4002C22.7715 19.5996 23.1276 19.7471 23.3901 20.0097C23.6527 20.2722 23.8002 20.6283 23.8002 20.9996C23.8002 21.3709 23.6527 21.727 23.3901 21.9896C23.1276 22.2521 22.7715 22.3996 22.4002 22.3996H5.6002C5.22889 22.3996 4.8728 22.2521 4.61025 21.9896C4.34769 21.727 4.2002 21.3709 4.2002 20.9996Z",
    fill: "#2D3134"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu_icon.e05abbc66e33b1f40e9fe51cddb82eee.svg";
export { ForwardRef as ReactComponent };